import { useEffect, useState } from "react";
import { adminAPI } from "@/lib/api";

// Anciens règlements écrits avec un code accentué : rattachés au code du tenant, à l'affichage seulement.
const DISPLAY_ALIASES = { "prélèvement": "prelevement" };

let cache = null;
let pending = null;
const listeners = new Set();
export let paymentMethodsFetchCount = 0;

const fetchOnce = () => {
  if (!pending) {
    paymentMethodsFetchCount += 1;
    pending = adminAPI.listPaymentMethods()
      .then((r) => {
        cache = { options: r.data?.options || [], defaultValue: r.data?.default || "" };
        listeners.forEach((fn) => fn(cache));
        return cache;
      })
      .catch(() => { pending = null; return cache; });
  }
  return pending;
};

/** Pièce jointe « photo du chèque » : tout mode dont le CODE contient « cheque » (ex. virement_cheque). */
export const isChequeMode = (code) => (code || "").includes("cheque");

/** À appeler quand la liste change (admin) ou quand on change de tenant. */
export const invalidatePaymentMethods = () => {
  cache = null;
  pending = null;
  if (listeners.size) fetchOnce();
};

/** Liste du tenant chargée une seule fois et partagée entre toutes les fenêtres. */
export const usePaymentMethods = () => {
  const [state, setState] = useState(cache);
  useEffect(() => {
    listeners.add(setState);
    if (cache) setState(cache); else fetchOnce();
    return () => listeners.delete(setState);
  }, []);
  const options = state?.options || [];
  const defaultValue = (state?.defaultValue && options.some((m) => m.value === state.defaultValue))
    ? state.defaultValue : (options[0]?.value || "");
  const label = (code) => {
    if (!code) return "";
    const key = DISPLAY_ALIASES[code] || code;
    return options.find((m) => m.value === key)?.label || code;
  };
  // Un mode stocké absent de la liste reste proposé et sélectionné, tel quel.
  const optionsWith = (code) => (code && !options.some((m) => m.value === code)
    ? [...options, { value: code, label: `${label(code)} (hors liste)` }] : options);
  // Opération affectée depuis un relevé bancaire = virement reçu, si le tenant a ce code.
  const bankTransferMode = options.some((m) => m.value === "virement") ? "virement" : defaultValue;
  return { options, defaultValue, bankTransferMode, label, optionsWith, loaded: !!state };
};
